<template>
  <div class="app">
    <div class="m-viewport" id="mainView">

        <!-- <div class="cover">
            <video autoplay="autoplay" loop="loop" muted="muted" playsinline>
                <source :src='"https://web-resource.17m3.com/m3guo/202511/vote/cover.mp4?v=" + randomKey'  type="video/mp4">
            </video>
        </div> -->

        <div class="logo-view left">
          <h2 class="logo"></h2>
        </div>
        
        <div class="logo-view right">
          <h2 class="logo_1"><a href="https://www.dianhun.cn/" target="_blank" rel="noopener noreferrer"></a></h2>
          <h2 class="logo_2"><a href="https://www.m3guo.com/v2/" target="_blank" rel="noopener noreferrer"></a></h2>
        </div>
        
        <!-- <div class="main-title"></div> -->
       
        <loading v-show="Loading"/>
     
        <!-- <div class="page-body" v-if="ready"> -->
        <div class="page-body">

            <div class="surpoort-area">
                <div class="surpoort-pannel flex-center-center">
                    <!-- <div class="list main">
                        <div class="logo JD sprite_logo-JD"></div>
                    </div> -->
                    <div class="list sp">
                        <div class="logo lg"></div>
                        <div class="logo zy"></div>
                        <!-- <div class="logo mg sprite_logo-mg"></div>
                        <div class="logo kh sprite_logo-kh"></div>
                        <div class="logo e sprite_logo-e"></div> -->
                    </div>
                    <!-- <div class="list live">
                        <div class="logo hy sprite_logo-hy"></div>
                        <div class="logo dy sprite_logo-dy"></div>
                    </div> -->
                </div>
            </div>
            
            <div class="page-wrapper">
                <div class="bracket-area body-item" id="div0">
                    <div class="title-match"></div>
                    <div class="plan-view">
                        <div class="slogen-mpl"></div>
                        <div class="img-view">
                            <img :src="main_img" v-if="main_img" alt="" srcset="">
                        </div>
                    </div>

                    <div class="guess-view">
                        <div class="slogen-guess"></div>
                        <user-info class="m-user"/>
                        <div class="u-btn rule" @click="$rule_modal()"></div>
                        <bracket :teamdic="teams" @select="onBracketSelect" @champion="onChampion" @third="onThird" />
                    </div>

                     <div class="reward-list list-1">
                        <ul>
                            <li v-for="(item,index) in list_1" :key="index">
                                <div class="reward-item">
                                    <div class="item-wrapper">
                                        <div class="item-pic" v-tips="item.code">
                                            <game-item :locked="true" :id="item.code" :num="item.qty"></game-item>
                                        </div>
                                    </div>                             
                                </div>
                                <div class="gift-name">{{ item.level }}</div>                                
                            </li>
                        </ul>
                     </div>

                     


                </div>

                <div class="vote-area body-item" id="div1">
                    <vote :options="team_data" @vote-cast="handleVoteCast"/>
                </div>

                <media :news_data="news_data" :main_news="main_news" :video_list="video_list"/>
            </div>
        </div>

        <div class="u-nav side">
            <div class="u-btn nav n-1" :class="{'act' : active == 0}" @click="scrollTo(0)"></div>
            <div class="u-btn nav n-2" :class="{'act' : active == 1}" @click="scrollTo(1)"></div>
            <div class="u-btn nav n-3" :class="{'act' : active == 2}" @click="scrollTo(2)"></div>
            <div class="u-btn nav n-4" :class="{'act' : active == 3}" @click="scrollTo(3)"></div>
        </div>

    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import { teams as teamsList, team_data as teamDataList } from '@/assets/data/teams.js'

import {
    apiVotePlayer,
    apiVoteTeam,
    apiNewsList,
} from '@/api/index';

export default {
    name: 'mainview',
    components: {
        //'user-info': () => import('@/components/UserInfo.vue'),
        loading: () => import('@/components/loading.vue'),
        bracket: () => import('@/components/Bracket.match.vue'),
        vote : () => import('@/components/Vote.vue'),
        media : () =>  import('@/views/media.vue'),
    },
    computed : {
        ...mapState(['Loading']),
    },    
    props : {
        ready : {
            default : false,
        },
    },  
    data() {
        return {
            // 示例 4 支队伍（从 external data 读取）
            teams: teamsList,
            list_1 :   [
                { level: '参与奖', code: 'MW62', name: '娱乐星赛季动态称号（30天）', qty: 1 },
                { level: 1, code: 'NH05', name: '竞技地图畅玩礼包（7天）', qty: 10 },
                { level: 2, code: 'D701', name: '星赛季特效道具自选包(7天)', qty: 1 },
                { level: 3, code: 'OV74', name: '冠军换装自选包', qty: 1 },

                { level: 4, code: 'B060', name: '星赛季台牌饰(180天）', qty: 1 },

                { level: 5, code: 'OV11', name: '2024星赛季冠军封灵玉自选包(30天)', qty: 1 },
                { level: 6, code: 'J338', name: '星运玄灵', qty: 1 },
            ],
            selectedGift: null,
            team_data: teamDataList,
            active_index : 0,
            active : 0,
            item_top_data : [],
            headerFixed : false,  
            randomKey : Math.random().toString(36).substring(2,8),
            news_data : [],
            main_news : [{} , {} , {} , {} ,{} ,{}],
            video_list : [{} , {} , {} , {} ,{} ,{}],
            main_img : '',                       
        }
    },
    mounted (){
        this.collect_top_data();
        this.$nextTick(function () {
            window.addEventListener('scroll', this.handleScroll)
        })
        
        this.fetch_content();
    },       
    methods: {
        fetch_content(){
            // this.news_data = this.$store.state.ex_list.filter(ele => ele.part == 2);
            // this.video_list = this.$store.state.ex_list.filter(ele => ele.part == 3);
            apiNewsList().then(res => {
                if(!res.data) return;
                this.news_data = res.data.filter(ele => ele.part == 2);
                this.video_list = res.data.filter(ele => ele.part == 3);
                this.main_img = res.data.filter(ele => ele.part == 1)[0].pcImgUrl;
            })
        },        
        onBracketSelect(payload) {
            // payload: {type: 'semi'|'loser'|'final'|'third', ...}
            console.log('bracket select', payload);
        },
        onChampion(team) {
            // 显示获胜队伍
            this.$toast && this.$toast('冠军：' + (team && team.name ? team.name : ''));
        },
        onThird(team) {
            this.$toast && this.$toast('季军：' + (team && team.name ? team.name : ''));
        },
        handleVoteCast(data) {

            if(!this.$store.state.login){
                return this.$mslogin.open();
            }
            if(!this.$store.state.userinfo.areaId){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            
            if(data.length < 10)return this.$msg_modal('请选择完整的阵容进行提交');


            
            let submit = [];
            data.forEach(item => {
                submit.push({
                    code : ['A' , 'B'][item.aid - 1] + item.pid,
                    name : item.name,
                    count : 1,
                    sort : 0,
                });
            });

            apiVotePlayer(submit).then(res => {
                this.$msg_modal('恭喜您，投票成功！感谢您的支持~');
            },
            rej=>{
                this.$msg_modal(rej.message || '操作失败，请稍后重试');
            }).catch(err => {
                    this.$msg_modal('操作失败，请稍后重试');
            });
        },
        handleScroll () {
            var self = this;
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop//获取滚动距离
            this.scrollTop = scrollTop//data里return了一个全局的scrollTop
            this.headerFixed = scrollTop > 1150


            //this.collect_top_data();

            // var result = collectActiveNav(100);
            // this.active = result[0];

            if(scrollTop < 2000){
                this.active = 0;
            }
            else if(scrollTop >= 2000 && scrollTop < 3200){
                this.active = 1;
            }
            else if(scrollTop >= 3200 && scrollTop < 4000){
                this.active = 2;
            }
            else if(scrollTop >= 4000){
                this.active = 3;
            }
            
   
            function collectActiveNav(delta){
                var ret = [] ;

                let body_item = document.querySelectorAll('.body-item');

                for (var i = 0; i < body_item.length; i++) {
                    let ele = body_item[i];
                    if (inViewport(i,delta,ele)){
                        ret.push(i);
                    }                                 
                }

                return ret;
            };

            function inViewport(i, delta,ele){
                var top = self.item_top_data[i],
                    scrollTop = self.scrollTop;
                
                delta = delta || 100;
                
                //return top + delta > scrollTop && top - delta < scrollTop + document.documentElement.clientHeight;
                return top - delta + ele.offsetHeight > scrollTop && top - delta < scrollTop + 0.5 * document.documentElement.clientHeight;
            };	         
        },
        collect_top_data (){
            let body_item = document.querySelectorAll('.body-item');

            this.item_top_data = [];

            for (var i = 0; i < body_item.length; i++) {
                this.item_top_data.push(body_item[i].offsetTop);
            }
          
        },
        scrollTo(index){
            // 定义一次跳 50 个像素，数字越大跳得越快，但是会有掉帧得感觉

            let h = [0,2000,3200,4000];
            const STEP = 50
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop//获取滚动距离
            let body_item = document.getElementById(`div${index}`);
            let top = index == -1 ? 0 : h[index];
            var targetOffsetTop = top;

            if (scrollTop < targetOffsetTop) {
                // 往下滑
                smoothDown()
            }else{
                smoothUp()
            }
            // 定义下滑函数
            function smoothDown() {
                // 如果当前 scrollTop 小于 targetOffsetTop 说明视口还没滑到指定位置
                if (scrollTop < targetOffsetTop) {
                    if (targetOffsetTop - scrollTop >= STEP) {
                        scrollTop += STEP
                    } else {
                        scrollTop = targetOffsetTop
                    }
                    document.body.scrollTop = scrollTop
                    document.documentElement.scrollTop = scrollTop
                    // 屏幕在绘制下一帧时会回调传给 requestAnimationFrame 的函数
                    requestAnimationFrame(smoothDown)
                }
            }
            // 定义上滑函数
            function smoothUp() {
                // 如果当前 scrollTop 大于 targetOffsetTop 说明视口已经滑过指定位置需要上滑
                if (scrollTop > targetOffsetTop) {
                    if (scrollTop - targetOffsetTop >= STEP) {
                        scrollTop -= STEP
                    } else {
                        scrollTop = targetOffsetTop
                    }
                    document.body.scrollTop = scrollTop
                    document.documentElement.scrollTop = scrollTop
                    requestAnimationFrame(smoothUp)
                }
            }
        },          
    },
}
</script>

<style lang="scss" scoped>
.m-viewport{
    position: relative;
    width: 100%;
    min-width: 1200px;
    max-width: 1920px;
    // height: 8000px;
    margin: 0 auto 0;
    box-sizing: border-box;
    font-size: 16px;
    background-color: #341e0d;
    color: #9f9891;
    overflow-x: hidden;
    overflow-y: hidden;
    // font-family: "HYChangLiSongKeBenJ";

    b{
        font-weight: 400;
        color: #26c7da;        
    }
}

.cover{
    position: absolute;
    left: 50%;
    top: -42px;
    width: 1920px;
    height: 1080px;
    transform: translateX(-50%);
    z-index: 1;
    overflow: hidden;
    // background-color: #000;

    video{
        width: 100%;
        height: 100%;
        object-fit: cover;
        border: none;
        mix-blend-mode: darken; 
    }

    &::after{
        content: '';
        display: block;
        width: 100%;
        height: 184px;
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        // background: linear-gradient(to bottom, rgba(52,30,13,0) 0%, rgba(52,30,13,1) 100%);
        background-image: url(~@/assets/images/xiao.png);
    }
}

.logo-view{
    display: flex;
    align-items: center;
    position: absolute;    
    top:30px;
    z-index: 3;

    &.left{
        left: 2%;
    }

    &.right{
        right: 2%;
    }
}

.logo-view a{
    display: block;
    width: 100%;
    height: 100%;
}

.logo-view .logo{
    width: 191px;
    height: 112px;
    background-image: url(~@/assets/images/logo_left.png);
}

.logo-view.right{
    width: 256px;
    height: 70px;
    background-image: url(~@/assets/images/logo_right.png);
}

.logo-view .logo_1{
    width: 50%;
    height: 70px;
    //background-image: url(~@/assets/images/pc/logo.png);
}

.logo-view .logo_2{
    width: 50%;
    height: 70px;
    //background-image: url(~@/assets/images/pc/logo-vip.png);
}

.u-links{
    display: flex;
    position: absolute;
    right: 4%;
    top: 50px;
    z-index: 3;
    width: 204px;
    height: 28px;
    //background-image: url(~@/assets/images/pc/btn-web.png);
}

.btn-index{
    width: 50%;
    height: 28px;
    // background-image: url(~@/assets/images/pc/btn-web.png);

}

.btn-dl{
    width: 50%;
    height: 28px;
    // background-image: url(~@/assets/images/pc/btn-dl.png);
   
}

.u-links a{
    display: block;
    width: 100%;
    height: 100%;
}

.main-title{
    position: absolute;
    left: 50%;
    top: 26px;
    width: 1367px;
    height: 484px;
    margin-left: -683.5px;
    background-image: url(~@/assets/images/main-title.png);
    z-index: 3;
    animation: float_up 4s ease-in-out infinite;
}

.icon-md{
    position: absolute;
    left: 50%;
    top: 784px;
    width: 115px;
    height: 71px;
    margin-left: -57.5px;
    //background-image: url(~@/assets/images/pc/icon-md.png);
    z-index: 3;
    animation: float_up 4s ease-in-out infinite;
}

.m-user{
    font-size: 20px;
    margin-top: 10px;
    margin-bottom: 85px;
    text-align: center;
}

.page-body{
    position: relative;
    width: 100%;
    min-width: 1200px;
    max-width: 1920px;
    height: calc(8000px - 42px);
    padding-top: 980px;
    background-repeat: no-repeat;
    background-position: center -42px;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: hidden;
    background-image: url(~@/assets/images/body.jpg);   
}

.page-wrapper{
    margin: 0 auto;

    .mid{
        width: 1304px;
        margin: 0 auto;
    }
}

.surpoort-area{
    margin: 0 20px 100px;
    .list{
        display: flex;
        align-items: center;
        background-repeat: no-repeat;
        background-position: left center;
        margin: 0 15px;


        &.main{
            padding-left: 140px;
            background-image: url(~@/assets/images/label-surport.png);
        }

        &.sp{
            padding-left: 140px;
            background-image: url(~@/assets/images/label-surport_sp.png);
        }

        &.live{
            padding-left: 100px;
            background-image: url(~@/assets/images/label-live.png);
        }        
    }

    .logo{
        margin: 0 20px;

        &.lg{
            width: 240px;
            height: 34px;
            background-image: url(~@/assets/images/suport/logo-lg.png);
        }

        &.zy{
            width: 300px;
            height: 31px;
            background-image: url(~@/assets/images/suport/logo-zy.png);
        }
    }
}

.bracket-area{
    .title-match{
        width: 481px;
        height: 129px;
        margin: 0 auto 10px;
        background-image: url(~@/assets/images/title-1.png);   
    }

    .slogen-mpl{
        width: 1105px;
        height: 86px;
        margin: 0 auto;
        background-image: url(~@/assets/images/slogen-mpl.png);         
    }

    .plan-view{
        width: 1870px;
        height: 900px;
        margin: 0 auto 0;        
    }

    .img-view{
        width: 1399px;
        height: 759px;
        margin: 0 auto 20px;
        text-align: center;
        //background-image: url(~@/assets/images/match-view.png);
        background-size: 100% 100%;

        img{
            width: 100%;
            height: 100%;
        }
    }

    .guess-view{
        position: relative;
        width: 1400px;
        margin: 0 auto 28px;

        .u-btn.rule{
            position: absolute;
            top: 75px;
            right: 0;
            width: 133px;
            height: 30px;
            background-image: url(~@/assets/images/btn-rule.png);
            cursor: pointer;
        }
    }

    .slogen-guess{
        width: 218px;
        height: 55px;
        margin: 0 auto;
        background-image: url(~@/assets/images/slogen-guess.png);            
    }

.reward-list{
    position: relative;
    width: 1400px;
    height: 162px;
    margin: 0 auto;
    
    
    &.list-1{
        background-image: url(~@/assets/images/pannel-reward.png);
    }
    
    ul{
        display: flex;
        padding-left: 240px;
        width: 1400px;
        height: 100%;
        box-sizing: border-box;
        justify-content: space-around;
        align-items: center;

        li{

            .reward-item{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 84px;
                height: 84px;
                margin: 0 auto;
                background-image: url(~@/assets/images/bg-item.png);

                .item-pic{
                    width: 64px;
                    height: 64px;
                }
            }

            .gift-name{
                margin-top: 10px;
                text-align: center;
                color: #d02907;
                font-size: 22px;
                font-weight: 700;
            }
        }
    }
}


}

.vote-area{
    margin-top: 240px;
}

.u-nav.side{
  position: fixed;
  right: 0;
  top: 50%;
  z-index: 20;

  .u-btn{
    width: 200px;
    height: 80px;

    @for $i from 1 through 4{
        &.n-#{$i}{
            background-image: url(~@/assets/images/sidenav/#{$i}.png);
            
            &:hover{
              background-image: url(~@/assets/images/sidenav/#{$i}D.png); 
            }
            &.act{
                background-image: url(~@/assets/images/sidenav/#{$i}D.png); 
            }                    
        }
    }     
  }
}

</style>

<style lang="scss">
.u-btn.submit{
    width: 364px;
    height: 107px;
    margin: 20px auto 0;
    background-image: url(~@/assets/images/btn-submit.png);
    cursor: pointer;
}

.u-btn.vote{
    width: 364px;
    height: 107px;
    margin: 20px auto 0;
    background-image: url(~@/assets/images/btn-submit_p.png);
    cursor: pointer;
}
</style>
